import { useRef } from 'react';
import { useAppDispatch } from '../../../app/hooks';
import { irParaPreviewImagem } from '../carteiraDocumentosSlice';
import { setArquivoTemp } from '../arquivoTemp';

const FORMATOS_ACEITOS = ['image/png', 'image/jpg', 'image/jpeg'];
const TAMANHO_MAXIMO = 2 * 1024 * 1024;

export const useUploadWeb = () => {
  const dispatch = useAppDispatch();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleSelecionarGaleria = () => {
    if (fileInputRef.current) {
      fileInputRef.current.accept = '.png,.jpg,.jpeg';
      fileInputRef.current.removeAttribute('capture');
      fileInputRef.current.click();
    }
  };

  const handleTirarFoto = () => {
    if (fileInputRef.current) {
      fileInputRef.current.accept = 'image/*';
      fileInputRef.current.setAttribute('capture', 'environment');
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!FORMATOS_ACEITOS.includes(file.type)) {
      alert('Formato não aceito. Selecione um arquivo PNG, JPG ou JPEG.');
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    if (file.size > TAMANHO_MAXIMO) {
      alert('O arquivo excede o tamanho máximo de 2MB.');
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    const fileURL = URL.createObjectURL(file);
    setArquivoTemp({ blob: file, nomeArquivo: file.name, mimeType: file.type, tamanhoBytes: file.size });
    dispatch(irParaPreviewImagem({ imagemSrc: fileURL, isPdf: false }));
  };

  return { fileInputRef, handleSelecionarGaleria, handleTirarFoto, handleFileChange };
};
